const DocumentForward = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19Z"
      fill="#3B4567"
    />
    <path
      d="M15.8001 2.21048C15.3901 1.80048 14.6801 2.08048 14.6801 2.65048V6.14048C14.6801 7.60048 15.9201 8.81048 17.4301 8.81048C18.3801 8.82048 19.7001 8.82048 20.8301 8.82048C21.4001 8.82048 21.7001 8.15048 21.3001 7.75048C19.8601 6.30048 17.2801 3.69048 15.8001 2.21048Z"
      fill="#3B4567"
    />
    <path
      d="M11 17.7504C10.81 17.7504 10.62 17.6804 10.47 17.5304C10.18 17.2404 10.18 16.7604 10.47 16.4704L11.19 15.7504H7C6.59 15.7504 6.25 15.4104 6.25 15.0004C6.25 14.5904 6.59 14.2504 7 14.2504H11.19L10.47 13.5304C10.32 13.3804 10.25 13.1904 10.25 13.0004C10.25 12.8104 10.32 12.6204 10.47 12.4704C10.76 12.1804 11.24 12.1804 11.53 12.4704L13.53 14.4704C13.66 14.6004 13.73 14.7704 13.74 14.9304C13.74 14.9804 13.74 15.0404 13.74 15.0904C13.72 15.2304 13.66 15.3604 13.56 15.4804C13.55 15.4904 13.53 15.5104 13.52 15.5204L11.52 17.5204C11.38 17.6804 11.19 17.7504 11 17.7504Z"
      fill="#3B4567"
    />
  </svg>
);

export default DocumentForward;
